<template>
  <v-row class="px-2">
    <v-col
      cols="12"
      sm="6"
      lg="3"
      v-for="(item, index) in cartas"
      :key="index"
    >
      <v-card class="pa-4 rounded-xl elevation-2 border-0" color="white">
        <div class="d-flex align-center">
          <v-avatar color="#F4F7FE" size="60" class="mr-4">
            <v-icon size="30" :color="item.color">{{ item.icono }}</v-icon>
          </v-avatar>

          <div class="flex-grow-1">
            <div class="caption font-weight-bold" style="color: #A3AED0; text-transform: uppercase; letter-spacing: 0.5px;">
              {{ item.nombre }}
            </div>
            <div class="text-h5 font-weight-black" style="color: #1B2559;">
              {{ item.total }}
            </div>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "CartasPersonalizadas",
  props: ["cartas"],
};
</script>


// WEBPACK FOOTER //
// src/components/Dialogos/CartasPersonalizadas.vue